module.exports = __webpack_public_path__ + "static/media/300dpi_Logo_Colour.0f9f266d.png";